import React, { useState, useMemo } from 'react';
import { Segmented, Row, Col, Typography } from 'antd';

import { getColor } from '../../helpers/utils';
import EmailUsageCurrentMonthGauge from './EmailUsageCurrentMonthGauge';
import EmailUsageMonthlyChart from './EmailUsageMonthlyChart';

const { Title, Text } = Typography;

const SEGMENT_CURRENT = 'current';
const SEGMENT_MONTHLY = 'monthly';

/**
 * Email usage section with top-right Segmented:
 * 1. Current month (e.g. "March 2026") → this month gauge (lg: left info, right chart)
 * 2. Monthly usage → last 12 months bar chart
 */
const EmailUsageSection = () => {
  const [segment, setSegment] = useState(SEGMENT_CURRENT);

  const currentMonthLabel = useMemo(() => {
    const d = new Date();
    return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }, []);

  const options = [
    { label: currentMonthLabel, value: SEGMENT_CURRENT },
    { label: 'Monthly usage', value: SEGMENT_MONTHLY },
  ];

  return (
    <div className="email-usage-section">
      <Row gutter={[16, 16]} align="middle" justify="space-between" style={{ marginBottom: 12 }}>
        <Col flex="1 1 auto" style={{ minWidth: 0 }}>

        </Col>
        <Col flex="0 0 auto">
            <Segmented
              options={options}
              value={segment}
              onChange={setSegment}
            />
        </Col>
      </Row>

      {segment === SEGMENT_CURRENT ? (
        <Row>
          <Col span={24}>
            <EmailUsageCurrentMonthGauge />
          </Col>
        </Row>
      ) : (
        <EmailUsageMonthlyChart months={12} chartType="bar" />
      )}
    </div>
  );
};

export default EmailUsageSection;
